import { useEffect, useState } from 'react';

/**
 * Package-local copy of the portal's useDebounce. Duplicated deliberately: a package
 * cannot import from apps/portal, and the portal helper stays for its non-CRUD callers.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
